import { RcFile } from 'antd/es/upload';
export const FILE_UPLOAD_GENERAL_ERROR = 'No pudimos adjuntar el documento.';
export const FILE_UPLOAD_LARGE_ERROR = 'No puede subir archivos de más de 10 MB';

// export type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];
export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export function formatRUT(rut: string, options?: { dots: boolean }): string {
  // Remove all non-digit characters except 'K' or 'k', which can be a verification digit.
  let cleanRut = rut.replace(/[^0-9a-zA-Z]/g, '');

  // Extract the verification digit.
  const verificationDigit = cleanRut.slice(-1);
  cleanRut = cleanRut.slice(0, -1);

  // Format the numeric part of the RUT.
  let formattedRut = '';
  if (options?.dots) {
    // Add dots for thousands, millions, etc.
    while (cleanRut.length > 3) {
      const chunk = cleanRut.slice(-3);
      formattedRut = `.${chunk}${formattedRut}`;
      cleanRut = cleanRut.slice(0, -3);
    }
    formattedRut = cleanRut + formattedRut;
  } else {
    // No dots, just concatenate the numeric part.
    formattedRut = cleanRut;
  }

  // Return the formatted RUT with the verification digit.
  return `${formattedRut}-${verificationDigit}`;
}
